import React, { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useChat } from '../contexts/ChatContext';
import AstroLoginInterface from './AstroLoginInterface';
import CallInterface from './chat/CallInterface';
import TranscriptPanel from './TranscriptPanel';
import './CampaignApp.css';

const AstroCampaignApp = () => {
  const { isAuthenticated, voiceConnected, logout } = useAuth();
  const { messages, TAB_TYPES, changeTab } = useChat();
  const [callEnded, setCallEnded] = useState(false);
  const [showTranscript, setShowTranscript] = useState(false);

  // When authenticated, switch to call interface tab and show the call interface with transcript
  useEffect(() => {
    if (isAuthenticated && voiceConnected) {
      changeTab(TAB_TYPES.CALL_INTERFACE);
    }
  }, [isAuthenticated, voiceConnected, changeTab, TAB_TYPES.CALL_INTERFACE]);

  // Show login if not authenticated or call has ended
  if (!isAuthenticated || callEnded) {
    return <AstroLoginInterface onCallEnd={() => setCallEnded(false)} />;
  }

  const handleEndCall = async () => {
    try {
      console.log('🔚 AstroCampaignApp: Ending astrology session...');

      // Step 1: Logout from authentication system
      await logout();
      console.log('🔓 AstroCampaignApp: Logged out successfully');

      // Step 2: Set call ended state to trigger login interface
      setCallEnded(true);
      console.log('🏁 AstroCampaignApp: Call ended, redirecting to login interface');

      // Step 3: Small delay to ensure state updates, then force redirect if needed
      setTimeout(() => {
        window.location.reload();
      }, 1000);

    } catch (error) {
      console.error('❌ AstroCampaignApp: Error ending astrology session:', error);

      // Even if logout fails, still redirect to login
      setCallEnded(true);

      // Emergency redirect after a short delay
      setTimeout(() => {
        console.log('🚨 AstroCampaignApp: Emergency redirect to login after error');
        window.location.href = '/';
      }, 500);
    }
  };

  // Get transcript from messages
  const getTranscript = () => {
    return messages
      .filter(msg => msg.type === 'user_speech_chunk' || msg.type === 'ai_speech_chunk')
      .map(msg => ({
        id: msg.id,
        speaker: msg.type === 'user_speech_chunk' ? 'You' : 'Luna',
        text: msg.content,
        timestamp: new Date(msg.timestamp)
      }));
  };

  return (
    <div className="campaign-app">
      <div className="campaign-header">
        <h2>🔮 Live Astrology Consultation with Luna</h2>
        <div className="campaign-actions">
          <button
            className="transcript-toggle-btn"
            onClick={() => setShowTranscript(!showTranscript)}
          >
            {showTranscript ? 'Hide Transcript' : 'View Transcript'}
          </button>
          <button
            className="end-campaign-btn"
            onClick={handleEndCall}
          >
            End Session
          </button>
        </div>
      </div>

      <div className="campaign-content">
        <CallInterface onEndCall={handleEndCall} />

        {showTranscript && (
          <TranscriptPanel
            transcript={getTranscript()}
            onClose={() => setShowTranscript(false)}
          />
        )}
      </div>
    </div>
  );
};

export default AstroCampaignApp;